import { BlankPage } from "@/components";
import { StoreModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Component, PropSync, Vue, Watch } from "vue-property-decorator";

@Component<LightBoxInsert>({
  components: {
    BlankPage
  }
})
export default class LightBoxInsert extends Vue {
  @PropSync("show", { type: Boolean })
  syncedShow!: boolean;
  @PropSync("type", { type: Number })
  syncedType!: number;

  private searchInput = "";
  private searchList = TCBReceiptApi.Protobuf.StoreList.create({
    list: [],
    total: -1
  });

  @Watch("syncedShow")
  onSyncedShowChange(show: boolean) {
    if (show) {
      this.reset();
    }
  }

  private reset() {
    this.searchInput = "";
    this.searchList = TCBReceiptApi.Protobuf.StoreList.create({
      list: [],
      total: -1
    });
  }

  private async search() {
    const item = TCBReceiptApi.Protobuf.StoreInsertQuery.create();
    switch (this.syncedType) {
      case 1:
        item.type = TCBReceiptApi.Protobuf.StoreInsertQueryType.SIQT_CODE;
        break;
      case 2:
        item.type = TCBReceiptApi.Protobuf.StoreInsertQueryType.SIQT_TID_NUMBER;
        break;
      case 3:
        item.type = TCBReceiptApi.Protobuf.StoreInsertQueryType.SIQT_TID_NUMBER;
        break;
    }
    item.identification = this.searchInput;
    const storeInsertQuery = TCBReceiptApi.Protobuf.StoreInsertQuery.encode(
      item
    ).finish();

    await StoreModel.getStoreSearch(storeInsertQuery);
    this.searchList = StoreModel.getStoreInsertList();
  }

  private takeIn(index: number) {
    this.$emit(
      "takeIn",
      (this.searchList.list as TCBReceiptApi.Protobuf.IStore[])[index]
    );
  }

  private closeLightBox() {
    this.$emit("closeLightBox");
  }
}
